import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { Close, ArrowBack, Fullscreen, FullscreenExit } from '@mui/icons-material';
import PropTypes from 'prop-types';
import './PanelHeader.css';

const PanelHeader = ({
  title,
  subtitle,
  onClose,
  onBack,
  onExpand,
  showBackButton = false,
  showExpandButton = false,
  showCloseButton = true,
  isExpanded = false,
  children,
}) => {
  return (
    <Box className="panel-header">
      <Box className="panel-header-title-container">
        {showBackButton && onBack && (
          <Tooltip title="Back">
            <IconButton className="panel-header-action-btn" size="small" onClick={onBack}>
              <ArrowBack fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        <Box className="panel-header-content">
          {typeof title === 'string' ? (
            <Typography className="panel-header-title">{title}</Typography>
          ) : (
            title
          )}
          {subtitle && <Typography className="panel-header-subtitle">{subtitle}</Typography>}
        </Box>
      </Box>

      <Box className="panel-header-actions">
        {children}
        {showExpandButton && onExpand && (
          <Tooltip title={isExpanded ? 'Collapse' : 'Expand'}>
            <IconButton className="panel-header-action-btn" size="small" onClick={onExpand}>
              {isExpanded ? <FullscreenExit fontSize="small" /> : <Fullscreen fontSize="small" />}
            </IconButton>
          </Tooltip>
        )}
        {showCloseButton && onClose && (
          <Tooltip title="Close">
            <IconButton className="panel-header-action-btn" size="small" onClick={onClose}>
              <Close fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};

PanelHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  subtitle: PropTypes.string,
  onClose: PropTypes.func,
  onBack: PropTypes.func,
  onExpand: PropTypes.func,
  showBackButton: PropTypes.bool,
  showExpandButton: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  isExpanded: PropTypes.bool,
  children: PropTypes.node,
};

export default PanelHeader;
